import E from "../pages/Dashboard.module.css";
import D from "../pages/ListDam.module.css";
import S from "./MyGauge.module.css";
import React from "react";
import ReactSpeedometer from "react-d3-speedometer";
import EchartGauge from "./echartGauge";
import EchartGaugespeedo2 from "./EchartGaugeAllSpeedo";
import { Col, Container, Row } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import StChart from "./StockChart";
import StChart2 from "./StockChart2";
import TabChart from "./tabCharts/tabChart";
import CattleListCardDash from "./CattleListDash.js/CattleListCardDash";
import PiComponent from "./PiChart/PiComponent";
import {
  NotificationsPaused,
  StackedLineChart,
  ThermostatAutoOutlined,
  TrendingUp,
  WaterDropRounded,
} from "@mui/icons-material";
const a = [
  { comp: "24 ساعت گذشته" },
  { comp: "30 روز گذشته (8 ساعته)" },
  { comp: "30 روز گذشته (720 ساعت) " },
  { comp: "30 روز گذشته (24 ساعته)" },
];

export function totalMinutesToHourMinute(value) {
  const hours = Math.floor(value / 60);
  const minutes = value - hours * 60;
  return {
    hours: hours,
    minutes: minutes,
    time: `${hours}  ساعت و ${minutes} دقیقه`,
    timeAsNumber: +`${hours}.${Math.floor(minutes * 1.667)}`,
  };
}
function CalcaulateRange(value, levels) {
  let level = levels ? levels : [1, 2, 3, 4];
  if (value <= level[0]) return <h4 style={{ color: "red" }}>🔴 هشدار</h4>;
  if (value <= level[1])
    return <h4 style={{ color: "orange" }}>🟠 نا مطلوب</h4>;
  if (value <= level[2]) return <h4 style={{ color: "green" }}>🟢 طبیعی</h4>;
  if (value <= level[3])
    return (
      <h4 style={{ color: "yellow", textShadow: "2px 2px 2px black" }}>
        🟡 بیش از حد
      </h4>
    );
}

const textColor = "#AAA";

const NoSegmentLabels = ({
  hours720,
  averageStat,
  label,
  stats,
  chart,
  hour8,
  day30,
  dataPI,
  tempHum,
}) => (
  <div>
    <div
      className={S.GaugesContainer}
      style={{ marginBottom: "20px", direction: "rtl" }}
    >
      <div className={S.GaugeItemo}>
        <h3>میانگین جویدن {label}</h3>

        <span>در 24 ساعت گذشته</span>
        <span>
          {CalcaulateRange(
            label === "گله" || label === "بهاربند"
              ? averageStat?.chewingLevel.value
              : averageStat?.chewingLevel?.value,
            label === "گله" || label === "بهاربند"
              ? averageStat?.chewingLevel.levelValues
              : averageStat?.chewingLevel?.levelValues
          )}
          <br />
          {
            totalMinutesToHourMinute(
              label === "گله" || label === "بهاربند"
                ? averageStat?.chewing
                : averageStat?.chewing
            ).time
          }
        </span>
        <div className={S.GaugeOverflow}>
          <ReactSpeedometer
            ringWidth={70}
            needleHeightRatio={0.5}
            needleColor="#445F34"
            segments={10}
            value={
              totalMinutesToHourMinute(
                label === "گله" || label === "بهاربند"
                  ? averageStat?.chewing
                  : averageStat?.chewing
              ).timeAsNumber
            }
            // maxValue={1000}
            maxValue={10}
            textColor={textColor}
          />
        </div>
      </div>
      <div className={S.GaugeItemo}>
        <h3>میانگین استراحت {label}</h3>
        <span>در 24 ساعت گذشته</span>
        <span>
          {CalcaulateRange(
            label === "گله" || label === "بهاربند"
              ? averageStat?.restingLevel.value
              : averageStat?.restingLevel?.value,
            label === "گله" || label === "بهاربند"
              ? averageStat?.restingLevel.levelValues
              : averageStat?.restingLevel?.levelValues
          )}
          <br />{" "}
          {
            totalMinutesToHourMinute(
              label === "گله" || label === "بهاربند"
                ? averageStat?.restingLevel.value
                : averageStat?.restingLevel?.value
            ).time
          }
        </span>
        <div className={S.GaugeOverflow}>
          <ReactSpeedometer
            ringWidth={70}
            startColor={"#570006"}
            endColor={"#00FF00"}
            needleColor="#445F34"
            maxValue={16}
            needleHeightRatio={0.5}
            segments={16}
            value={
              totalMinutesToHourMinute(
                label === "گله" || label === "بهاربند"
                  ? averageStat?.restingLevel.value
                  : averageStat?.restingLevel?.value
              ).timeAsNumber
            }
            textColor={textColor}
          />
        </div>
      </div>
      <div className={S.GaugeItemo}>
        <h3>میانگین نشخوار {label}</h3>
        <span>در 24 ساعت گذشته</span>
        <span>
          {CalcaulateRange(
            label === "گله" || label === "بهاربند"
              ? averageStat?.ruminationLevel.value
              : averageStat?.ruminationLevel?.value,
            label === "گله" || label === "بهاربند"
              ? averageStat?.ruminationLevel.levelValues
              : averageStat?.ruminationLevel?.levelValues
          )}
          <br />
          {
            totalMinutesToHourMinute(
              label === "گله" || label === "بهاربند"
                ? averageStat?.ruminationLevel.value
                : averageStat?.rumination
            ).time
          }
        </span>
        <div className={S.GaugeOverflow}>
           <ReactSpeedometer
            ringWidth={70}
            needleHeightRatio={0.5}
            needleColor="#445F34"
            maxValue={10}
            startColor={"#570006"}
            endColor={"#31FF00"}
            segments={10}
            value={
              totalMinutesToHourMinute(
                label === "گله" || label === "بهاربند"
                  ? averageStat?.ruminationLevel.value
                  : averageStat?.ruminationLevel.value
              ).timeAsNumber
            }
            textColor={textColor}
          />
        </div>
      </div>
    </div>
    <Container style={{ maxWidth: "1620px" }}>
      <Row>
        <Col sm="12" md="12" xl="3">
          <Row style={{ marginTop: "40px" }}>
            {label === "گله" && (
              <Col>
                <div className={`${S.GaugeItemo2}`}>
                  <EchartGauge
                    statHum={
                      label === "گله" || label === "بهاربند"
                        ? Math.floor(averageStat?.humidity)
                        : Math.floor(averageStat?.humidity)
                    }
                  />
                  {console.log(tempHum)}
                  <p style={{ color: "skyblue" }} className="lastTempHum">
                    <WaterDropRounded /> آخرین رطوبت :{" "}
                    {tempHum && +tempHum?.hum?.toFixed(1)}
                  </p>
                </div>
              </Col>
            )}

            {label === "گله" && (
              <Col>
                <div className={`${S.GaugeItemo2}`}>
                  <EchartGauge
                    stat={
                      label === "گله" || label === "بهاربند"
                        ? Math.floor(averageStat?.temperature)
                        : Math.floor(averageStat?.temperature)
                    }
                    label={"دما"}
                  />
                  <p
                    style={{ color: "rgb(255, 171, 145)" }}
                    className="lastTempHum"
                  >
                    <ThermostatAutoOutlined /> آخرین دما :{" "}
                    {+tempHum?.temp?.toFixed(1)}
                  </p>
                </div>
              </Col>
            )}
            {label === "بهاربند" && (
              <Col>
                <div className={`${S.GaugeItemo2}`}>
                  <EchartGauge
                    statHum={
                      label === "گله" || label === "بهاربند"
                        ? Math.floor(averageStat?.humidity)
                        : Math.floor(averageStat?.humidity)
                    }
                  />
                  <p style={{ color: "skyblue" }} className="lastTempHum">
                    <WaterDropRounded /> آخرین رطوبت :{" "}
                    {+tempHum?.hum?.toFixed(1)}
                  </p>
                </div>
              </Col>
            )}

            {label === "بهاربند" && (
              <Col>
                <div className={`${S.GaugeItemo2}`}>
                  <EchartGauge
                    stat={
                      label === "گله" || label === "بهاربند"
                        ? Math.floor(averageStat?.temperature)
                        : Math.floor(averageStat?.temperature)
                    }
                    label={"دما"}
                  />
                  <p
                    style={{ color: "rgb(255, 171, 145)" }}
                    className="lastTempHum"
                  >
                    <ThermostatAutoOutlined /> آخرین دما :{" "}
                    {+tempHum?.temp?.toFixed(1)}
                  </p>
                </div>
              </Col>
            )}
            <Col>
              <div className={`${S.GaugeItemo2}`}>
                <EchartGaugespeedo2
                  standsleep={{
                    sleep: averageStat?.sleeping,
                    stand: averageStat?.standing,
                  }}
                  label={"ایستادن"}
                  stat={
                    label === "گله" || label === "بهاربند"
                      ? Math.floor(averageStat?.standing)
                      : Math.floor(averageStat?.standing)
                  }
                />
                <p style={{ fontWeight: "bold" }} className="lastTempHum2">
                  <StackedLineChart fontSize="large" /> میانگین 24 ساعت ایستادن{" "}
                </p>
              </div>
            </Col>
            <Col>
              <div className={`${S.GaugeItemo2}`}>
                <EchartGaugespeedo2
                  standsleep={{
                    sleep: averageStat?.sleeping,
                    stand: averageStat?.standing,
                  }}
                  label={"خواب"}
                  stat={
                    label === "گله" || label === "بهاربند"
                      ? Math.floor(averageStat?.sleeping)
                      : Math.floor(averageStat?.sleeping)
                  }
                />
                <p style={{ fontWeight: "bold" }} className="lastTempHum2">
                  <NotificationsPaused fontSize="large" /> میانگین 24 ساعت خواب{" "}
                </p>
              </div>
            </Col>

            <Col>
              <div className={`${S.GaugeItemo2}`}>
                <EchartGaugespeedo2
                  label={"فعالیت"}
                  stat={
                    label === "گله" || label === "بهاربند"
                      ? Math.floor(averageStat?.activity)
                      : Math.floor(averageStat?.activity)
                  }
                />
                <p style={{ fontWeight: "bold" }} className="lastTempHum2">
                  <TrendingUp fontSize="large" /> میانگین 24 ساعت فعالیت{" "}
                </p>
              </div>
            </Col>

            <Col>
              <div className={`${S.GaugeItemo2}`}>
                <EchartGaugespeedo2
                  label={"استرس"}
                  stat={
                    label === "گله" || label === "بهاربند"
                      ? Math.floor(averageStat?.unrest)
                      : Math.floor(averageStat?.unrest)
                  }
                />
                <p style={{ fontWeight: "bold" }} className="lastTempHum2">
                  <StackedLineChart fontSize="large" /> میانگین 24 ساعت استرس{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Col>

        <Col
          sm="12"
          md="12"
          xl="9"
          style={{ margin: "px auto", padding: "0px" }}
        >
          {label === "گله" && (
            <Col>
              <div
                style={{
                  height: "auto",
                  marginTop: "50px",
                  marginBottom: "40px",
                }}
              >
                <PiComponent data={dataPI} />
              </div>
            </Col>
          )}
          {label === "بهاربند" && (
            <Col>
              <div
                style={{
                  height: "auto",
                  marginTop: "50px",
                  marginBottom: "40px",
                }}
              >
                <PiComponent data={dataPI} label="بهاربند" />
              </div>
            </Col>
          )}
          {label === "گله" && (
            <Col>
              <TabChart
                hours720={hours720 && hours720}
                chart={chart && chart}
                hour8={hour8 && hour8}
                day30={day30 && day30}
                label={label}
              />
            </Col>
          )}
          {label === "دام" && (
            <Col>
              <TabChart
                hours720={hours720 && hours720}
                chart={chart && chart}
                hour8={hour8 && hour8}
                day30={day30 && day30}
                label={label}
              />
            </Col>
          )}
          {label === "بهاربند" && (
            <Col>
              <TabChart
                hours720={hours720 && hours720}
                chart={chart && chart}
                hour8={hour8 && hour8}
                day30={day30 && day30}
                label={label}
              />
            </Col>
          )}

          {/* {label==='گله'&&
          <Col>
                    <CattleListCardDash/>
          </Col>
          } */}
        </Col>
      </Row>
    </Container>
  </div>
);
export default NoSegmentLabels;
